import { getLocalStorageItem, setLocalStorageItem, removeLocalStorageItem } from 'helpers/Storage';
import _ from 'lodash';

export const isFilterActive = (pathName = '', filter = '') => {
  const currentPath = window?.location?.pathname?.split('/')[1];
  const decodedPath = decodeURI(pathName);
  return decodedPath.includes(`/${currentPath}/${filter}`.toLowerCase());
};

export const handleSavedSearches = (searchValue, searchResults) => {
  const { recentSearchesMaxSaved } = window?.ExternalConfig;
  const searchTabs = [];
  const storedRecentSearch = getLocalStorageItem({ key: 'recentSearch' });
  const storedTerms = storedRecentSearch?.split('~').map(word => word?.toLowerCase().trim()) ?? [];
  const cleanedSearch = searchValue
    .replaceAll('%', '')
    .toLowerCase()
    .trim();
  const isTermStored = storedTerms.includes(cleanedSearch);
  if (!isTermStored && cleanedSearch.length > 0 && searchResults.length > 0) {
    if (storedTerms.length === recentSearchesMaxSaved) storedTerms.shift();
    storedTerms?.push(cleanedSearch);
    const newStoredTerms = storedTerms.join('~');
    setLocalStorageItem({ key: 'recentSearch', value: newStoredTerms });
  }
  const recentTabs = storedTerms?.map(term => ({
    headline: term?.toUpperCase(),
    id: _.camelCase(term),
  }));
  const addTabs = recentTabs?.filter(
    tab => !searchTabs?.find(filter => filter.headline === tab.headline),
  );
  searchTabs.push(...addTabs);
  return searchTabs;
};

export const clearSavedSearches = () => {
  removeLocalStorageItem({ key: 'recentSearch' });
};
